export function formatCooldown(ms: number): string {
  const h = Math.floor(ms / 3_600_000)
  const m = Math.floor((ms % 3_600_000) / 60_000)
  const s = Math.floor((ms % 60_000) / 1000)
  const parts: string[] = []
  if (h > 0) parts.push(`${h}ч`)
  if (m > 0) parts.push(`${m}м`)
  parts.push(`${s}с`)
  return parts.join(' ')
}

export function formatTimer(seconds: number): string {
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
}

export function formatDateTime(value: string | null): string {
  if (!value) return '—'
  const d = new Date(value.replace(' ', 'T'))
  if (isNaN(d.getTime())) return value
  return d.toLocaleString('ru-RU', { dateStyle: 'short', timeStyle: 'short' })
}

export function parseNextAllowedAt(raw: number | string | null | undefined): number | null {
  if (raw == null || raw === '') return null
  if (typeof raw === 'number') return raw < 1e12 ? raw * 1000 : raw
  const parsed = Date.parse(String(raw))
  return Number.isNaN(parsed) ? null : parsed
}

export function qrImageUrl(data: string, size = 300): string {
  return `/api/qr-code?data=${encodeURIComponent(data)}&size=${size}&margin=2`
}
